export default __webpack_public_path__ + "static/media/image16.ba284a2c.png";